import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=3bf31366&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.scss?vue&type=style&index=0&id=3bf31366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf31366",
  null
  
)

export default component.exports